import React from "react";
import skill from "../images/skill.png";
import "./styles.css";

const Skill = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img
            src={skill}
            alt="Skill"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Skills</div>

          <div className="pbody">
            <p> Languages: JavaScript, MATLAB, Python </p>
            <p>
              {" "}
              Web Dev : ReactJS, Redux, styled-components, Sass, HTML, CSS{" "}
            </p>
            <p> Simulation : Arduino </p>
            <p> Others: Git, Unix </p>

            <a
              className="pbottom"
              href="https://medium.com/@menidhikjha"
            >
              Checkout my blogs
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Skill;
